/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { useMutation } from '@tanstack/react-query';

import { ApiError, DownloadTenantReleaseResponse, DownloadTenantReleaseRequestSchema } from '@/client';
import { mgmtPlaneAPIClient } from '@/client/mgmtPlane';
import { useMgmtPlaneStateStore } from '@/state/mgmtPlaneStore';

export type DownloadTenantReleaseMutationConfig = {
  onSuccess?: (data: DownloadTenantReleaseResponse) => void;
  onError?: (error: unknown) => void;
};

export function useDownloadTenantReleaseMutation(config?: DownloadTenantReleaseMutationConfig) {
  const tenantId = useMgmtPlaneStateStore((state) => state.selectedTenantID);

  const mutation = useMutation<
    DownloadTenantReleaseResponse,
    ApiError,
    { releaseId: string; requestBody: DownloadTenantReleaseRequestSchema }
  >({
    mutationFn: ({ releaseId, requestBody }) => {
      return mgmtPlaneAPIClient.tenantReleases.downloadTenantRelease({
        tenantId: tenantId!,
        releaseId,
        requestBody,
      });
    },
    onError: config?.onError,
    onSuccess: config?.onSuccess,
  });

  return mutation;
}
